"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextareaInput = exports.MIN_WIDTH_TEXT_AREA_INPUT = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const styles_1 = require("../../helpers/styles");
exports.MIN_WIDTH_TEXT_AREA_INPUT = helpers_1.FIELD_XXS;
exports.StyledTextareaInput = styled_components_1.default.textarea `
    outline: none;
    box-sizing: border-box;
    border-width: ${helpers_1.BASE_BORDER_WIDTH};
    border-style: solid;
    padding: ${helpers_1.SPACING_S};
    background-color: #fff;
    font: ${helpers_1.BASE_FONT};
    min-height: 30px;
    resize: none;
    min-width: ${exports.MIN_WIDTH_TEXT_AREA_INPUT};
    width: ${({ size }) => (typeof size === 'string' ? size : (0, styles_1.calcWidth)(size))};

    ${({ fullWidth }) => fullWidth &&
    (0, styled_components_1.css) `
            width: 100%;
        `}

    ${({ theme }) => (0, styled_components_1.css) `
        border-color: ${theme.colorBorderMain};
        color: ${theme.colorTextMain};

        ::placeholder {
            color: ${theme.colorTextLight};
        }

        :-ms-input-placeholder {
            color: ${theme.colorTextLight};
        }

        ::-ms-input-placeholder {
            color: ${theme.colorTextLight};
        }

        &:focus {
            border-color: ${theme.colorControlBorderAccent};
        }

        &:disabled {
            border-color: ${theme.colorBackgroundDisabled};
            background-color: ${theme.colorBackgroundDisabled};
            color: ${theme.colorTextLight};
        }
    `}

    ${({ error, theme }) => error &&
    (0, styled_components_1.css) `
            &,
            &:focus {
                background-color: ${theme.colorBackgroundError};
                border-color: ${theme.colorBorderError};
            }
        `}
`;
//# sourceMappingURL=TextareaInput.styles.js.map